import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { adminLogout } from '../utils/api';

const AdminRouteGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    const isLoggedIn = localStorage.getItem('adminLoggedIn');
    
    // If admin is logged in but navigating away from admin pages
    if (isLoggedIn && !currentPath.startsWith('/admin/')) {
      const handleAutoLogout = async () => {
        try {
          await adminLogout();
        } catch (error) {
          // Silent error handling for auto-logout
        } finally {
          // Always clear localStorage and redirect
          localStorage.removeItem('adminLoggedIn');
          localStorage.removeItem('adminInfo');
        }
      };
      
      handleAutoLogout();
    }
  }, [location.pathname, navigate]);

  return null; // This component doesn't render anything
};

export default AdminRouteGuard;
